import { Link } from "react-router-dom";
import { MapPin, Briefcase, Clock, Banknote } from "lucide-react";
import VerifiedBadge from "@/components/VerifiedBadge";
import { fileUrl } from "@/lib/api";

function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))} dk önce`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} saat önce`;
  return `${Math.floor(diff / 86400)} gün önce`;
}

export default function JobCard({ job }) {
  const logo = job.employer_logo_file_id ? fileUrl(job.employer_logo_file_id) : null;
  return (
    <Link
      to={`/ilan/${job.slug}`}
      data-testid={`job-card-${job.id}`}
      className="group block bg-white border border-slate-200 rounded-2xl p-5 hover:border-blue-500 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-200"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center overflow-hidden shrink-0">
          {logo ? (
            <img src={logo} alt={job.company_name} className="w-full h-full object-contain" />
          ) : (
            <Briefcase className="text-blue-600" size={22} />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-semibold text-[#1f222d] text-base leading-snug group-hover:text-blue-700 transition-colors line-clamp-2">
              {job.title}
            </h3>
            {job.match_score != null && (
              <span className="shrink-0 text-xs font-bold text-blue-700 bg-blue-50 border border-blue-200 rounded-full px-2 py-1">
                %{job.match_score} uyum
              </span>
            )}
          </div>
          <div className="flex items-center gap-1.5 mt-1 text-sm text-slate-600">
            <span className="truncate">{job.company_name}</span>
            {job.employer_verified && <VerifiedBadge size={15} />}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mt-4 text-xs text-slate-600">
        <span className="inline-flex items-center gap-1 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-1">
          <MapPin size={13} /> {job.location}
        </span>
        <span className="inline-flex items-center gap-1 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-1">
          <Clock size={13} /> {job.work_type}
        </span>
        {job.salary && (
          <span className="inline-flex items-center gap-1 bg-blue-50 text-blue-700 border border-blue-100 rounded-lg px-2.5 py-1 font-medium">
            <Banknote size={13} /> {job.salary}
          </span>
        )}
      </div>

      {job.match_reason && (
        <p className="mt-3 text-xs text-slate-500 line-clamp-2 bg-blue-50/50 rounded-lg p-2 border border-blue-100">
          <span className="font-semibold text-blue-700">AI:</span> {job.match_reason}
        </p>
      )}

      <div className="flex items-center justify-between mt-4 pt-3 border-t border-slate-100">
        <span className="text-xs text-slate-400">{timeAgo(job.created_at)}</span>
        <span className="text-xs font-semibold text-blue-600 group-hover:translate-x-1 transition-transform inline-block">
          Detaylar →
        </span>
      </div>
    </Link>
  );
}
